import React from 'react'


import {
    Card,
     } from "react-bootstrap" 

function RecentWork(){
    return (
       
        <Card className="Recent" body>Recent Work.</Card>
    )
}

export default RecentWork;